/* ============================================================
   DEATHDOSE RESPAWN — Shopify integration layer (25 Sep 2026)
   Loaded after respawn.js by sections/respawn-nav.liquid.
   respawn.js stays a 1:1 port of the standalone build; storefront-only
   behaviour lives here.
   ============================================================ */
(function(){
"use strict";
if(window.__ddRespawnShopify) return;
window.__ddRespawnShopify=1;

/* 1. Nav "stuck" state. Horizon makes .page-wrapper the scroll container at >=990px
      (html/body are overflow:hidden), so window.scrollY stays 0 and respawn.js never
      sees the page scroll. Watch the element that actually scrolls. */
var nav=document.getElementById('nav'), pw=document.querySelector('.page-wrapper');
function stuck(){
  if(!nav) return;
  var y=Math.max(window.scrollY||0, pw?pw.scrollTop:0);
  nav.classList.toggle('dd-is-stuck', y>18);
}
if(pw) pw.addEventListener('scroll',stuck,{passive:true});
window.addEventListener('scroll',stuck,{passive:true});
stuck();

/* 1b. Product page gallery (sections/respawn-product): thumbnails swap the main image;
       arrow keys move between thumbnails (tab pattern). */
[].forEach.call(document.querySelectorAll('[data-gal]'),function(g){
  var imgs=g.querySelectorAll('.dd-gal__img[data-i]'), th=g.querySelectorAll('.dd-gal__thumb');
  function show(i){
    [].forEach.call(imgs,function(im){ im.hidden=(im.getAttribute('data-i')!==String(i)); });
    [].forEach.call(th,function(b){ var on=b.getAttribute('data-i')===String(i); b.setAttribute('aria-selected',on?'true':'false'); b.tabIndex=on?0:-1; });
  }
  [].forEach.call(th,function(b,k){
    b.tabIndex=(b.getAttribute('aria-selected')==='true')?0:-1;
    b.addEventListener('click',function(){ show(b.getAttribute('data-i')); });
    b.addEventListener('keydown',function(e){
      var n=e.key==='ArrowRight'?k+1:e.key==='ArrowLeft'?k-1:null; if(n===null) return;
      n=(n+th.length)%th.length; e.preventDefault(); th[n].focus(); show(th[n].getAttribute('data-i'));
    });
  });
});

/* 1c. Measurement (29 Sep 2026). Publishes Shopify custom events so the owner can see, per visit, which
       homepage sections were actually seen and what people did — the evidence the next redesign should be
       based on. Read them with a custom pixel (Settings › Customer events). Events:
         dd_section_view {section}   first time each homepage section is 40% on screen (v10: + story, nofear, squadup)
         dd_signup {source}         Squad comms email form submitted (v5)
         dd_quick_pick {plan}       'Pick your build' chip used (v6)
         dd_faq_open     {question}  an FAQ answer opened
         dd_loadout_open             "View full loadout" opened
         dd_plan_select  {plan}      a plan picked in the purchase panel
         dd_game         {action}    hero battle: "perk" (squad button tapped) / "execute" (enemy tapped), first of each
       Nothing personal is sent. */
function pub(name,data){ try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish(name,data||{}); }catch(e){} }
if('IntersectionObserver' in window){
  var seen={}, io=new IntersectionObserver(function(es){ es.forEach(function(e){
    var id=e.target.id; if(e.isIntersecting&&id&&!seen[id]&&(e.intersectionRatio>=.4||e.intersectionRect.height>=window.innerHeight*.4)){ seen[id]=1; pub('dd_section_view',{section:id}); io.unobserve(e.target); } }); },{threshold:[0,.05,.1,.2,.3,.4]}); /* v10: sections taller than 2.5 screens can never be 40% visible, so also count 40% of the screen filled */
  ['top','player','loadout','build','compare','founder','squad','story','protocol','order','nofear','faq','squadup','squad-comms'].forEach(function(id){ var el=document.getElementById(id); if(el) io.observe(el); });
}
document.addEventListener('toggle',function(e){
  var d=e.target; if(!d||d.tagName!=='DETAILS'||!d.open) return;
  if(d.id==='full-loadout') pub('dd_loadout_open');
  else if(d.closest('.dd-faq')){ var q=d.querySelector('summary'); pub('dd_faq_open',{question:q?q.textContent.trim():''}); }
},true);
document.addEventListener('change',function(e){ if(e.target&&e.target.name==='plan') pub('dd_plan_select',{plan:e.target.value}); });
var gameSent={};
document.addEventListener('submit',function(e){ if(e.target&&e.target.id==='dd-comms-form') pub('dd_signup',{source:'footer'}); },true);
document.addEventListener('dd:game',function(e){ var a=e.detail&&e.detail.action; if(a&&!gameSent[a]){ gameSent[a]=1; pub('dd_game',{action:a}); } });

/* 2. Order button. respawn.js (standalone demo) confirms "added to your loadout" without
      adding anything. On the storefront that must not happen, so this capture-phase
      listener takes the click first:
      - live (product published to Online Store): add the chosen variant/selling plan
        to the Shopify cart, then go to the cart;
      - not live: say plainly that orders are not open yet. */
var buy=document.getElementById('buy');
if(!buy) return;
var toast=document.getElementById('toast'), tT=document.getElementById('toastT'), tS=document.getElementById('toastS'), timer;
function say(t,s){
  if(!toast||!tT||!tS) return;
  tT.textContent=t; tS.textContent=s;
  toast.classList.add('dd-is-on'); clearTimeout(timer);
  timer=setTimeout(function(){ toast.classList.remove('dd-is-on'); },4200);
}
function resync(){
  var r=document.querySelector('input[name="plan"]:checked');
  if(r) r.dispatchEvent(new Event('change',{bubbles:true}));
}
document.addEventListener('click',function(e){
  if(!e.target.closest||!e.target.closest('#buy')) return;
  e.stopPropagation(); e.preventDefault();
  if(buy.getAttribute('aria-busy')==='true'||buy.disabled) return; /* W-9: disabled = sold out */
  if(buy.dataset.live!=='true'){
    say('Drop 001 opens soon','RESPAWN isn’t on sale online yet — nothing has been added or charged.');
    return;
  }
  var r=document.querySelector('input[name="plan"]:checked');
  if(!r||!r.dataset.variant){ say('Pick a loadout','Choose an option above first.'); return; }
  var item={id:parseInt(r.dataset.variant,10),quantity:1};
  if(r.dataset.plan) item.selling_plan=parseInt(r.dataset.plan,10);
  buy.setAttribute('aria-busy','true');
  fetch((buy.dataset.cartAdd||'/cart/add')+'.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:[item]})
  }).then(function(res){
    return res.json().then(function(j){ if(!res.ok) throw new Error(j.description||j.message||('HTTP '+res.status)); return j; });
  }).then(function(){
    buy.textContent='Equipped ✓ · Taking you to your cart';
    say('Item acquired · '+(r.dataset.label||'RESPAWN'),'RESPAWN ×1 added to your cart. You’re one of us now.');
    setTimeout(function(){ window.location.href=buy.dataset.cart||'/cart'; },900);
  }).catch(function(err){
    buy.removeAttribute('aria-busy');
    say('Couldn’t add to cart',(err&&err.message)?err.message:'Please try again in a moment.');
  });
},true);

/* Back button from the cart restores this page from bfcache: reset the CTA label. */
window.addEventListener('pageshow',function(e){ if(e.persisted){ buy.removeAttribute('aria-busy'); resync(); } });
})();

/* v8 (1 Oct 2026, copy audit): scroll XP bar under the nav (goal-gradient). A tick marks where each numbered section starts;
   the level tag shows the section in view.
   R4-Y (16 Oct 2026): derived from the page itself, not from a fixed homepage list. The levels are the <section> elements that
   hold a numbered eyebrow ("[03] // How to run it"), in DOM order; the tag shows that eyebrow's own number and title, the ticks sit
   at those sections' tops. Fewer than three numbered sections (cart, info pages, 404...) = no bar. */
(function(){
  try{
    var nav=document.getElementById('nav'); if(!nav) return;
    var re=/^\[(\d{2})\]\s*\/\/\s*(\S.*)$/;
    var secs=[], nums=[], names=[];
    [].forEach.call(document.querySelectorAll('.dd-eyebrow'),function(e){
      var m=re.exec((e.textContent||'').replace(/\s+/g,' ').trim()); if(!m) return;
      var s=e.closest('section'); if(!s || secs.indexOf(s)>-1) return;
      secs.push(s); nums.push(m[1]); names.push(m[2]);
    });
    if(secs.length<3) return;
    var xp=document.createElement('div'); xp.className='dd-xp'; xp.setAttribute('aria-hidden','true');
    var bar=document.createElement('i'); xp.appendChild(bar);
    var lvl=document.createElement('span'); lvl.className='dd-xp__lvl'; xp.appendChild(lvl);
    nav.appendChild(xp);
    var ticks=[], cur=-2, raf=0;
    /* Horizon makes .page-wrapper the scroll container at >=990px (window.scrollY stays 0): read both. */
    var pw=document.querySelector('.page-wrapper');
    function sy(){ return Math.max(window.scrollY||0, pw?pw.scrollTop:0); }
    function smax(){ return Math.max(1, Math.max(document.documentElement.scrollHeight, pw?pw.scrollHeight:0)-innerHeight); }
    function layout(){
      ticks.forEach(function(t){ t.remove(); }); ticks=[];
      var max=smax(), off=sy();
      secs.forEach(function(s){ var t=document.createElement('b'); t.style.left=Math.min(100,(s.getBoundingClientRect().top+off)/max*100)+'%'; xp.appendChild(t); ticks.push(t); });
    }
    function tick(){
      raf=0;
      var max=smax();
      xp.style.setProperty('--xp',Math.min(1,sy()/max).toFixed(4));
      var k=-1; secs.forEach(function(s,i){ if(s.getBoundingClientRect().top<innerHeight*.45) k=i; });
      if(k!==cur){ cur=k;
        if(k<0){ lvl.classList.remove('dd-on'); }
        else {
          lvl.textContent='LVL ';
          var em=document.createElement('em'); em.textContent=nums[k]; lvl.appendChild(em);
          lvl.appendChild(document.createTextNode(' · '+names[k]));
          lvl.classList.add('dd-on');
        }
      }
    }
    function onScroll(){ if(!raf) raf=requestAnimationFrame(tick); }
    addEventListener('scroll',onScroll,{passive:true});
    if(pw) pw.addEventListener('scroll',onScroll,{passive:true});
    addEventListener('resize',function(){ layout(); tick(); });
    addEventListener('load',function(){ layout(); tick(); });
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ layout(); tick(); });
    layout(); tick();
  }catch(e){}
})();
